/**
 * TerritorySelect Component
 * Dropdown for selecting territory with auto-complete
 */

import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getUniqueListBy } from "@components/Common/Function";
import { TERRITORY_PLACEHOLDER } from "../utils/wssConstants";
import "@components/Common/SearchableSelect.css";

const TerritorySelect = ({
  territoryOptions,
  selectedTerritory,
  onChange,
  disabled = false,
}) => {
  // Get unique territories by SH2_Code__c
  const uniqueTerritories = territoryOptions && territoryOptions.length > 0
    ? getUniqueListBy(territoryOptions, "SH2_Code__c")
    : [];

  return (
    <Autocomplete
      id="territory-select"
      className="myDealer__categorySelect"
      options={uniqueTerritories}
      getOptionLabel={(option) => {
        if (option?.SH2_Name__c) {
          return `${option?.SH2_Name__c} : ${option?.SH2_Code__c}`;
        }
        return "";
      }}
      value={selectedTerritory}
      onChange={(event, newValue) => {
        onChange(newValue || TERRITORY_PLACEHOLDER);
      }}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} placeholder="Select Territory" />
      )}
    />
  );
};

export default TerritorySelect;
